import clsx from 'clsx'
import React, { memo } from 'react'
import EditableContainer from '@v4/components/common/EditableContainer'
import EditableHTML from '@v4/components/common/EditableHTML'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import PropTypes from 'prop-types'
import ItemBorder from '@v4/components/common/ItemBorder'
import { useItem } from './Item.hooks'

const Item = props => {
	const [
		{
			classes,
			open,
			itemKey,
			group,

			title,
			titleKey,
			titleConfig,
			titleEditable,

			text,
			textKey,
			textConfig,
			textEditable,
		},
		{ handleTitleChange, handleTitleClick, handleTextClick, handleTextChange, handleClick },
	] = useItem(props)

	return (
		<ItemBorder itemKey={itemKey} group={group}>
			<ExpansionPanel
				className={clsx(classes.root, 'faq2-item-root')}
				classes={{
					rounded: classes.rounded,
				}}
				onClick={handleClick}
			>
				<ExpansionPanelSummary
					className={clsx(classes.summary, 'faq2-summary')}
					classes={{ content: classes.summaryContent, focused: classes.focused }}
					expandIcon={
						open ? (
							<RemoveIcon className={clsx(classes.icon, 'faq2-item-minus-icon')} />
						) : (
							<AddIcon className={clsx(classes.icon, 'faq2-item-plus-icon')} />
						)
					}
				>
					<EditableContainer
						visible={!!title}
						fieldConfig={titleConfig}
						onAdd={handleTitleChange}
						editable={titleEditable}
					>
						<EditableHTML
							className={clsx(classes.title, 'faq2-title-item')}
							html={title}
							onClick={handleTitleClick}
							editable={titleEditable}
							onChange={handleTitleChange}
							key={titleKey}
						/>
					</EditableContainer>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={clsx(classes.details, 'faq2-item-details')}>
					<EditableContainer
						visible={!!text}
						fieldConfig={textConfig}
						onAdd={handleTextChange}
						editable={textEditable}
					>
						<EditableHTML
							className="faq2-text-item"
							html={text}
							onClick={handleTextClick}
							editable={textEditable}
							onChange={handleTextChange}
							key={textKey}
						/>
					</EditableContainer>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		</ItemBorder>
	)
}

Item.propTypes = {
	group: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	itemKey: PropTypes.string.isRequired,
}

export default memo(Item)
